import React, { FC, useEffect, useState } from 'react';
import { SberPayButton, SberPayIconWrapper } from './SberPay.styled';
import { SberPayIcon } from '../../../core/icons/SberPayIcon';

type SberPayProps = {
    onClick: () => void;
    isLoading? : boolean;
};

export const SberPay: FC<SberPayProps> = ({ onClick, isLoading }) => {
    return <SberPayButton isLoading={isLoading} onClick={onClick}>Оплатить с <SberPayIconWrapper><SberPayIcon/></SberPayIconWrapper> Pay</SberPayButton>
}